"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typesAlias = exports.rpc = exports.types = void 0;

var _authority = _interopRequireDefault(require("./authority"));

var _graduallyUpdates = _interopRequireDefault(require("./graduallyUpdates"));

var _oracle = _interopRequireDefault(require("./oracle"));

var _rewards = _interopRequireDefault(require("./rewards"));

var _runtime = _interopRequireDefault(require("./runtime"));

var _tokens = _interopRequireDefault(require("./tokens"));

var _traits = _interopRequireDefault(require("./traits"));

var _utils = require("./utils");

var _vesting = _interopRequireDefault(require("./vesting"));

const defs = {
  authority: _authority.default,
  graduallyUpdates: _graduallyUpdates.default,
  oracle: _oracle.default,
  tokens: _tokens.default,
  traits: _traits.default,
  vesting: _vesting.default,
  rewards: _rewards.default,
  runtime: _runtime.default
};
const types = (0, _utils.typesFromDefs)(defs);
exports.types = types;
const rpc = (0, _utils.jsonrpcFromDefs)(defs);
exports.rpc = rpc;
const typesAlias = (0, _utils.typesAliasFromDefs)(defs);
exports.typesAlias = typesAlias;